import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BtnStatusComponent } from './btn-status.component';
import {ReactiveFormsModule} from '@angular/forms';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule
    ],
  declarations: [BtnStatusComponent],
  exports: [BtnStatusComponent]
})
export class BtnStatusModule { }



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/btn-status/btn-status.module.ts